<template>
    <div>
        <div class="block is-inline-flex">
            <p class="is-size-2 has-text-weight-bold">
                Meetings
            </p>
            <div class="buttons m-l-md">
                <b-button @click="isCreate=true">
                    Propose
                </b-button>
            </div>
        </div>
        <div class="block">
            <div class="box">
                <b-table
                :data="data.length>1 || isCreate ? data : []"
                :columns="columns"
                >
                    <template slot-scope="props">

                        <b-table-column v-if="props.row.create && isCreate">
                        </b-table-column>
                        <b-table-column v-if="props.row.create && isCreate">
                            <b-input v-model="props.row.name" placeholder="Enter name *">
                            </b-input>
                        </b-table-column>

                        <b-table-column v-if="props.row.create && isCreate" colspan="1">
                            <b-select v-model="props.row.client_user_id" placeholder="Enter client">
                                <option :value="client.id" v-for="(client,key) in clients" :key="key">{{client.attributes.email}}</option>
                            </b-select>
                        </b-table-column>
                        <b-table-column v-if="props.row.create && isCreate">
                        </b-table-column>

                        <b-table-column v-if="props.row.create && isCreate">
                            <span>
                                <div class="buttons">
                                    <b-button type="is-success" size="is-small" position="is-right" class="m0" @click="save">
                                        Save
                                    </b-button>
                                    <b-button type="is-danger" size="is-small" position="is-right" class="m0" @click="isCreate=false">
                                        Cancel
                                    </b-button>
                                </div>
                            </span>
                        </b-table-column>

                        <b-table-column v-if="!props.row.create">
                            <span>
                                {{props.row.id}}
                            </span>
                        </b-table-column>
                        <b-table-column v-if="!props.row.create">
                            <span>
                                {{props.row.attributes.name}}
                            </span>
                        </b-table-column>
                        <b-table-column v-if="!props.row.create">
                            <span>
                                {{props.row.attributes.client_user_id}}
                            </span>
                        </b-table-column>
                        <b-table-column v-if="!props.row.create">
                            <span>
                                {{props.row.attributes.created_by}}
                            </span>
                        </b-table-column>
                        <b-table-column v-if="!props.row.create">
                            <span>
                                <div class="buttons">
                                    <b-button type="is-primary" size="is-small" position="is-right" class="m0" @click="goTo('meetings.edit',{id:props.row.id})" icon-left="pencil"/>
                                    <b-button type="is-danger" size="is-small" position="is-right"  class="m0" @click="deleteMeeting(props.row)" icon-left="trash-can"/>
                                </div>
                            </span>
                        </b-table-column>
                    </template>
                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                    <b-icon icon="alert-decagram-outline" size="is-large"></b-icon>
                                </p>
                                <p>NO RESULTS FOUND</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
export default {
    data() {
        return {
            data:[
                {
                    create:true,
                    name:null,
                    client_user_id:null
                }
            ],
            isCreate:false,
            columns:[
                {
                    label:'Id',
                    field:'id'
                },
                {
                    label:'Name',
                    field:'name'
                },
                {
                    label:'Client',
                    field:'client_user_id'
                },
                {
                    label:'Created By',
                    field:'created_by'
                },
                {
                    label:'Actions',
                    field:'actions'
                },
            ],
            clients:[],
            page:1
        }
    },
    mounted() {
        this.getMeetings(this.page)
        this.getClients();
    },
    methods: {
        getMeetings(page=1) {
            Vue.$meetingService.meetingList(`?page=${page}`).then((response)=>{
                this.page++
                this.data.push(...response.data)
            })
        },
        getClients() {
            Vue.$userService.userList('?roles=gatekeeper').then((response)=>{
                this.clients = response.data
            })
        },
        goTo(name,params=null){
            this.$router.push({
                name:name,
                params:params ? params : {}
            })
        },
        save() {
            Vue.$meetingService.createMeeting({
                name: this.data[0].name,
                client_user_id: this.data[0].client_user_id
            }).then((response)=>{
                this.data.unshift(response.data)
                this.$buefy.toast.open({
                    type: 'is-success',
                    message: 'Meeting added!'
                })
                this.data = _.filter(this.data,(value)=>{
                    return value.create ? false : true
                })
                this.data.unshift({
                    create:true,
                    name:null,
                    client_user_id:null
                })
                this.isCreate = false
                this.$router.push({
                    name:'meetings.edit',
                    params:{
                        id:response.data.id
                    }
                })
            })
        },
        deleteMeeting(row) {
            this.$buefy.dialog.confirm({
                title: 'Deleting meeting',
                message: 'Are you sure you want to <b>delete</b> this meeting? This action cannot be undone.',
                confirmText: 'Delete meeting',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    Vue.$meetingService.delete(row.id).then(()=>{
                        this.$buefy.toast.open({
                            type: 'is-success',
                            message: 'Meeting deleted!'
                        });
                        let id = row.id;
                        this.data = _.filter(this.data,(value)=>{
                            return value.id!==id
                        });
                    })
                }
            });
        }
    }
}
</script>

<style scoped>
.box{
    box-shadow: 1px 2px 3px rgb(10 10 10 / 10%), 2px 3px 8px 1px rgb(10 10 10 / 10%);
}
</style>